import * as styles from './InputWrapError.module.css'

function InputWrapError({
  className = styles.InputWrapError,
  text,
  ...restProps
}) {
  return (
    <span {...restProps} className={className}>
      {text}
    </span>
  )
}

export default InputWrapError
